import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import * as Business from '../../utils/business'
import * as Http from '../../http'
import { ErrorCode } from '../../const'

export default class ListUser extends Component {
  state = {
    isShow: false
  }

  show = (roleInfo) => {
    this.roleInfo = { ...roleInfo }
    this.listRoles = Business.getRawListRole()

    this.setState({
      isShow: true
    })
  }

  close = () => {
    this.setState({
      isShow: false
    })
  }

  save = () => {
    if (!this.roleInfo.RoleGroupName) {
      Business.showAlert({
        title: 'Error',
        content: 'You must enter the role name'
      })
      return
    }
    this.roleInfo = {
      ...this.roleInfo,
      RoleList: JSON.stringify(this.listRoles)
    }

    Http.updateRole(this.roleInfo)
      .then(res => {
        if (res.Success) {
          Business.showAlert({
            title: 'Success',
            content: 'Update successful'
          })
          this.props.onRoleChange && this.props.onRoleChange()
          this.close()
        } else {
          switch (res.ErrorCode) {
            case ErrorCode.PermissionDenie:
              Business.showAlert({
                title: 'Error',
                content: 'You are not permission'
              })
              break;
            case ErrorCode.Exist:
              Business.showAlert({
                title: 'Error',
                content: 'The role name already exists in the system'
              })
              break;
            default:
              break;
          }
        }
      })
  }

  onSelect = index => {
    this.listRoles.map(item => {
      if (item.roleId === index) {
        if (item.select === '1') {
          item.select = '2'
        } else {
          item.select = '1'
        }
      }
    })
    this.forceUpdate()
  }

  render() {
    if (!this.state.isShow) return <div />

    return (
      <Modal show={this.state.isShow} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>Update role</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="form-group">
              <label for="exampleInputEmail1">Role name</label>
              <input type="text" className="form-control"
                id="exampleInputEmail1" aria-describedby="emailHelp"
                defaultValue={this.roleInfo.RoleGroupName}
                onChange={event => {
                  this.roleInfo.RoleGroupName = event.target.value
                }}
              />
            </div>
            {
              this.listRoles.map(item => (
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" value="" id="defaultCheck1"
                    onChange={() => this.onSelect(item.roleId)}
                    checked={item.select === '1'} />
                  <label className="form-check-label" for="defaultCheck1">
                    {item.roleName}
                  </label>
                </div>
              ))
            }
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" style={{
            backgroundColor: '#FFE600',
            borderColor: '#7F7E82',
            borderRadius: '5px',
            marginRight: '2px',
            fontWeight: 600,
            marginLeft: "auto"
          }} onClick={this.save}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/Role/UpdateUser.js